import React from 'react'
import {
  Typography,
  Button,
  CircularProgress,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import Wrapper from '../../../Common/Wrapper/Wrapper'
import useStyles from './BottomTools.style'
import FirmwareUpdate from './FirmwareUpdate/FirmwareUpdate'

const BottomTools = ({
  selectedMezzo,
  restoreUnitUsers,
  restoreUnitUsersInProgress,
  connectivity,
  availableFirmwares,
  firmwareStatus,
}) => {
  const classes = useStyles()

  return (
    <Wrapper>
      <Wrapper className={classes.bottomToolsWrapper}>
        <Wrapper className={classes.buttonWrapper}>
          <Typography className={classes.buttonTitle}>Restore Unit Users</Typography>
          <Button
            disabled={(selectedMezzo.serial === 'N/A' || selectedMezzo.serial === '') || connectivity === 'localComms'}
            className={classes.mezzoRescueButtons}
            variant="contained"
            color="primary"
            onClick={restoreUnitUsers}
          >
            {restoreUnitUsersInProgress ? (
              <CircularProgress
                color="primary"
                classes={{ colorPrimary: classes.circleColor }}
                size={30}
              />
            ) : 'Restore'}
          </Button>
        </Wrapper>
        <Wrapper className={classes.buttonWrapper}>
          <Typography className={classes.buttonTitle}>Backup Mezzo Data</Typography>
          <Button
            disabled
            className={classes.mezzoRescueButtons}
            variant="contained"
            color="primary"
            onClick={() => {
            }}
          >
            Backup
          </Button>
        </Wrapper>
        <Wrapper className={classes.buttonWrapper}>
          <Typography className={classes.buttonTitle}>Restore Mezzo Data</Typography>
          <Button
            disabled
            className={classes.mezzoRescueButtons}
            variant="contained"
            color="primary"
            onClick={() => {
            }}
          >
            Restore
          </Button>
        </Wrapper>
      </Wrapper>
      <FirmwareUpdate
        selectedMezzo={selectedMezzo}
        availableFirmwares={availableFirmwares}
        firmwareStatus={firmwareStatus}
      />
    </Wrapper>
  )
}

BottomTools.propTypes = {
  connectivity: PropTypes.string.isRequired,
  restoreUnitUsers: PropTypes.func.isRequired,
  restoreUnitUsersInProgress: PropTypes.bool.isRequired,
  selectedMezzo: PropTypes.shape({
    serial: PropTypes.string,
    identifier: PropTypes.string,
  }),
  availableFirmwares: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  firmwareStatus: PropTypes.shape({
    step: PropTypes.string,
    progress: PropTypes.number,
    totalProgress: PropTypes.number,
  }).isRequired,
}

BottomTools.defaultProps = {
  selectedMezzo: PropTypes.shape({
    serial: PropTypes.string,
    identifier: PropTypes.string,
  }),
}

export default BottomTools
